import React from 'react';
import { Datagrid, DeleteButton, EditButton, List } from 'react-admin';
import { Link } from 'react-router-dom';
import { linkToRecord } from 'ra-core';

import * as AccessCheck from '../../Common/Utils/AccessCheck';
import DateField from '../../Common/Utils/DateField';
import DocumentationTitleName from './StaticData/TitleName';
import RequiredRole from './StaticData/RequiredRole';
import SearchFilter from './Helpers/SearchFilter';

type TitleProps = {
  record: any,
  resource: string,
  source: string
};

const TitleLink = (props: TitleProps) => (
  <Link to={`${linkToRecord(props.resource, props.record.id)}/show`}>
    {props.record[props.source]}
  </Link>
);

type Props = {
  permissions: any,
  record: any,
  resource: string
};

const DocumentationList = (props: Props) => (
  <List filters={<SearchFilter />} title={DocumentationTitleName} sort={{ field: 'title', order: 'ASC' }} perPage={25} bulkActionButtons={false} {...props}>
    <Datagrid>
      <TitleLink record={props.record} resource={props.resource} source="title" />
      <DateField name="updated_at" source="updated_at" />
      {AccessCheck.Edit(props.permissions, RequiredRole, <EditButton />)}
      {AccessCheck.Delete(props.permissions, RequiredRole, <DeleteButton />)}
    </Datagrid>
  </List>
);

export default DocumentationList;



// WEBPACK FOOTER //
// ./src/views/Components/Documentations/List.tsx